<template>
<v-app id="app" :dark="isDark">
  <v-navigation-drawer v-if="$route.name !== 'dashboard' && $route.name !== 'landing' && $route.name !== 'create'" :clipped="drawer.clipped" :fixed="drawer.fixed" :permanent="drawer.permanent" :mini-variant="drawer.mini" v-model="drawer.open" app>
    <side-bar v-if="$route.params.groupID"></side-bar>
  </v-navigation-drawer>
  <v-toolbar :height="toolbar.height" :fixed="toolbar.fixed" :clipped-left="toolbar.clippedLeft" :clipped-right="toolbar.clippedRight" app>
    <div v-if="$route.params.groupID">
      <v-toolbar-side-icon v-if="!drawer.open" @click.stop="toggleDrawer"></v-toolbar-side-icon>
      <v-btn small flat fab v-else @click.stop="toggleDrawer">
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <router-link :to="{ path: '/'}">
      <svg xmlns="http://www.w3.org/2000/svg" class="logo" data-name="Layer 1" viewBox="0 0 452.1 468.2">
        <path class="d-black" d="M449.2 466.6h-45.8a2.1 2.1 0 0 1-1.7-.7l-41-43-43.7-45.8-35-36.7-36.2-37.9-36.3-38.2-36.4-38.2-32.5-34-36.4-38.2-2.8-2.9 26.1-24.8c1.7 1.5 3.4 2.9 4.9 4.5l41.6 43.6 55.5 58.2 47.9 50.3 47.2 49.5 40.1 42 42.4 44.5 37.5 39.3a31.8 31.8 0 0 0 3.1 3.2c1.7 1.3 1.9 3.1 1.5 5.3z"/>
        <path class="d-grey" d="M65.9 190.2l27.6-26.3 10 10.5 27.7 29.1 32.8 34.4 27.5 28.8 36.6 38.4 32.5 34 36.3 38.2 32.5 34 36.4 38.2 14.1 14.8a4.9 4.9 0 0 1 1.2 1.5c.6 1.7 0 2.5-1.8 2.5h-46.8a3.1 3.1 0 0 1-2.6-1.1c-5-5.4-10.1-10.6-15.1-15.9l-36.4-38.2-28.6-29.9-36.3-38.1-36.5-38.3-42.2-44.3-36.5-38.3-31.7-33.3z"/>
        <path class="d-grey" d="M55.9 190.2l27.6-26.3 10 10.5 27.7 29.1 32.8 34.4 27.5 28.8 36.6 38.4 32.5 34 36.3 38.2 32.5 34 36.4 38.2 14.1 14.8a4.9 4.9 0 0 1 1.2 1.5c.6 1.7 0 2.5-1.8 2.5h-46.8a3.1 3.1 0 0 1-2.6-1.1c-5-5.4-10.1-10.6-15.1-15.9l-36.4-38.2-28.6-29.9-36.3-38.1-36.5-38.3-42.2-44.3-36.5-38.3-31.7-33.3z"/>
        <path class="d-green" d="M145.8 116.3c8.2-6.1 24-14.8 33.7-18.3a136.3 136.3 0 0 1 97.4 1.7c29 11.5 53.3 33.5 68.7 61.8 5.6 10.5 10 22.4 13.4 36.7 2.3 9.4 2.4 12 1.9 31.3s-.9 21.5-4.5 33.6c-4.4 15.1-13.4 32.9-22.3 44.5l-6.2 8.1 31.2 32.4c17.2 17.8 31.5 32.2 31.7 32l6.3-7.2c14.2-16.3 29.6-41.3 38-61.8C477.6 206.6 437.7 89 340 30.9 303.7 9.3 261.5-1.3 217.1.1a219.9 219.9 0 0 0-110.6 34.1c-10.1 6.3-28.4 19.9-28 20.9s14.1 15.2 31 32.9l30.9 32.4z"/>
        <path class="d-black" d="M246.2 451.2c9.9-1 27.2-3.8 31.2-5.2 2.4-.8-.5-4.2-39.2-44.4-29.7-30.8-42.4-43.5-44.2-43.6-4.4-.1-25-8.4-34.8-13.9a141 141 0 0 1-63.1-77.2c-9-27.7-7.9-62.5 2.7-89.8 6.1-15.4 13.5-27.3 29.2-46.1l2.1-2.5-30.2-32c-16.5-17.5-30.6-32-31.4-32s-4.4 3.3-8.1 7.4a226.9 226.9 0 0 0-46.3 75.5c-28.9 78.8-12.9 164.9 42.5 228.4 28 32.1 73.2 59.5 114.3 69.4 22.6 5.4 54.2 8 75.3 6z"/>
        <path class="d-black" d="M434.8 466.6h-45.9a2.1 2.1 0 0 1-1.7-.7l-41-43-43.6-45.8-35-36.7-36.2-37.9-36.3-38.2-36.4-38.2-32.5-34-36.4-38.2L87 151l26-24.9c1.7 1.5 3.4 2.9 4.9 4.5l41.7 43.7 55.4 58.1 48 50.3 47.2 49.5 40.1 42.1 42.4 44.5 37.5 39.3a31.8 31.8 0 0 0 3.1 3.2c1.7 1.3 1.8 3.1 1.5 5.3z"/>
        <path class="d-green" d="M176.34330311 155.45681624l23.25704771-21.68754785 21.7080078 23.27898832-23.2570477 21.68754785z"/>
        <path class="d-black" d="M206.8922726 188.27606783l23.2570477-21.68754785 21.7080078 23.27898833-23.2570477 21.68754785z"/>
        <path class="d-green" d="M237.47304224 221.12218406l23.2570477-21.68754785 21.7080078 23.27898832-23.2570477 21.68754785z"/>
        <path class="d-black" d="M268.19514709 253.87323582l23.2570477-21.68754785 21.7080078 23.27898832-23.2570477 21.68754785zM218.04781233 119.02307451l23.2570477-21.68754785 21.70800781 23.27898833-23.25704771 21.68754785z"/>
        <path class="d-green" d="M248.6967818 151.84232611l23.25704772-21.68754785 21.7080078 23.27898832-23.25704771 21.68754785z"/>
        <path class="d-black" d="M279.25068682 184.5202425l23.25704771-21.68754785 21.7080078 23.27898832-23.2570477 21.68754785z"/>
        <path class="d-green" d="M309.8996563 217.3394941l23.25704771-21.68754786 21.7080078 23.27898833-23.2570477 21.68754785z"/>
      </svg>
      <!--<img src="./assets/logo.png" class="align-center" style="width:100%;max-width:55px;height:auto;" -->
    </router-link>
    <v-spacer></v-spacer>
    <NavBar v-if="$route.name !== 'landing'" />
    <v-btn v-if="$route.params.groupID" small flat fab @click.stop="toggleDrawerRight">
      <v-icon v-if="!drawerRight.open" title="Open Chat">forum</v-icon>
      <v-icon v-else title="Close Chat">cancel</v-icon>
    </v-btn>
    <v-btn small flat fab @click.stop="toggleSkin">
      <v-icon small>invert_colors</v-icon>
    </v-btn>
  </v-toolbar>
  <v-dialog v-model="drawerRight.open" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="green darken-1">
        <v-toolbar-title>
          <v-icon>forum</v-icon> Comments</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark flat @click="drawerRight.open = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <div v-if="$route.params.groupID">
        <chat :show="chatActive" :user="user" />
      </div>
      <v-container v-else>
        <p>Unavailable</p>
      </v-container>
    </v-card>
  </v-dialog>
  <v-content class="pt-2">
    <v-container fluid>
      <router-view/>
    </v-container>
  </v-content>
  <v-footer app :permanent="footer.permanent" :height="footer.height" :fixed="footer.fixed">
    <v-layout grid row wrap>
      <v-flex xs12 class="text-xs-right px-4">
        <p class="caption pt-3"><span class="footspan">&copy; {{ new Date().getFullYear() }} QIKBYTE</span>
          <Privacy></Privacy>
        </p>
      </v-flex>
    </v-layout>
  </v-footer>
</v-app>
</template>

<script>
import NavBar from "@/components/Navigation/NavBar";
import SideBar from "@/components/Navigation/SideBar";
import Chat from "@/components/Chat/Chat";
import Privacy from "@/components/Privacy/Privacy";

import {
  mapGetters
} from "vuex";

import firebase from "@/firebaseConfig";
export default {
  name: 'app',
  components: {
    NavBar,
    SideBar,
    Chat,
    Privacy
  },
  props: {
    source: String
  },
  data: function() {
    return {
      user: '',
      isActive: true,
      isDark: false,
      drawerRight: {
        // sets the open status of the drawer
        open: false,
        // sets if the drawer is shown above (false) or below (true) the toolbar
        clipped: true,
        // sets if the drawer is CSS positioned as 'fixed'
        fixed: true,
        // sets if the drawer remains visible all the time (true) or not (false)
        permanent: false,
        // sets the drawer to the mini variant, showing only icons, of itself (true)
        // or showing the full drawer (false)
        mini: false
      },
      right: true,
      drawer: {
        // sets the open status of the drawer
        open: true,
        // sets if the drawer is shown above (false) or below (true) the toolbar
        clipped: true,
        // sets if the drawer is CSS positioned as 'fixed'
        fixed: false,
        // sets if the drawer remains visible all the time (true) or not (false)
        permanent: false,
        // sets the drawer to the mini variant, showing only icons, of itself (true)
        // or showing the full drawer (false)
        mini: true
      },
      toolbar: {
        //
        fixed: true,
        height: "60px",
        // sets if the toolbar contents is leaving space for drawer (false) or not (true)
        clippedLeft: true,
        clippedRight: true
      },
      footer: {
        // sets the CSS position of the footer
        fixed: true,
        permanent: true,
        height: "30px",
      }
    }
  },
  methods: {
    toggleSkin: function() {
      this.isDark = !this.isDark
    },
    // changes the drawer to permanent
    makeDrawerPermanent() {
      this.drawer.permanent = true
      // set the clipped state of the drawer and toolbar
      this.drawer.clipped = false
      this.toolbar.clippedLeft = false
    },
    // toggles the drawer variant (mini/full)
    toggleMiniDrawer() {
      this.drawer.mini = !this.drawer.mini
    },
    // toggles the drawer type (permanent vs temporary) or shows/hides the drawer
    toggleDrawer() {
      if (this.drawer.permanent) {
        this.drawer.permanent = !this.drawer.permanent
        // set the clipped state of the drawer and toolbar
        this.drawer.clipped = true
        this.toolbar.clippedLeft = true
      } else {
        // normal drawer
        this.drawer.open = !this.drawer.open
      }
    },
    toggleDrawerRight() {
      if (this.drawerRight.permanent) {
        this.drawerRight.permanent = !this.drawerRight.permanent
        // set the clipped state of the drawer and toolbar
        this.drawerRight.clipped = true
        this.toolbar.clippedRight = true
      } else {
        // normal drawer
        this.drawerRight.open = !this.drawerRight.open
      }
    }
  },
  computed: {
    ...mapGetters(["chatActive"])
  },
  created() {
    // Keep track current logged in users
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.user = user;
        var today = new Date()
        var curHr = today.getHours()
        if (curHr < 5) {
          console.log('good morning')
          this.isDark = false
        } else if (curHr < 18) {
          this.isDark = false
          console.log('good afternoon')
        } else {
          this.isDark = true
          console.log('good evening')
        }
      } else {
        user = null;
      }
    });
  }
}
</script>

<style lang="scss">
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    padding: 0;
}
.theme--light.application {
    background: #e0e0e0;
    color: rgba(0,0,0,.87);
}
.footspan {
    position: absolute!important;
    top: 10px;
    right: 110px;
}
.privbtn {
    position: absolute!important;
    top: -2px;
    right: 4px;
}
svg.logo {
    margin-top: 8px;
    width: 35px;
}
.theme--dark {
    .d-black {
        fill: #dbd7ce;
    }
    .d-grey {
        fill: #b9b2a7;
    }
    .d-green {
        fill: #66bb6a;
    }
}
.d-grey {
    fill: #7a7a7a;
}
.d-green {
    fill: #43a047;
}
.d-black {
    fill: #070707;
}
code {
    padding: 4px;
    margin-bottom: 16px;
}
pre > code {
    padding: 10px 10px 0;
    margin-bottom: 16px;
}
hr {
    margin-bottom: 16px;
}
.editor-toolbar {
    background: #ffffff;
    opacity: 0.8;
}
.markdown-editor .editor-preview-active,
.markdown-editor .editor-preview-active-side {
    display: block;
}
.theme--dark.v-sheet {
    overflow-x: hidden;
}
.theme--light.v-sheet {
    overflow-x: hidden;
}
a {
    text-decoration: none;
}
.v-tabs__item.v-tabs__item--active {
    color: #81c784;
    .v-icon {
        color: #81c784;
    }
}
.CodeMirror,
.CodeMirror-scroll {
    min-height: 100px;
}
.v-expansion-panel {
    -webkit-box-shadow: none;
    box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue